import React, { memo } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import { getEventColor } from "pagesV2/pro/Calendar/utils"
import styles from "./index.module.css"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"

const BookingItem = ({ booking, conflict = false, setIsBookingModalOpen, setSelectedBookingId, compact = false }) => {
  const { start_time, end_time, uuid, experience_name, payment_status, booking_status } = booking || {}
  const fmt = (t) => (t ? moment(t, ["HH:mm:ss", "HH:mm", "h:mm A", "hh:mm A"]).format("h:mm A") : "")
  let eventTime = fmt(start_time)
  if (end_time) {
    eventTime += (eventTime ? " - " : "") + fmt(end_time)
  }
  const bgColor = getEventColor(payment_status, booking_status)

  const handleBookingClick = () => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(uuid)
  }

  return (
    <button
      type="button"
      className={compact ? `${styles.bookingBlock} ${styles.bookingBlockCompact}` : styles.bookingBlock}
      style={{ backgroundColor: bgColor }}
      onClick={handleBookingClick}
    >
      {eventTime && (
        <div className={styles.timeRow}>
          <span className={compact ? styles.timeTextCompact : styles.timeText}>{eventTime}</span>
          {conflict ? <BookingConflictWarning /> : null}
        </div>
      )}
      <span className={compact ? styles.titleTextCompact : styles.titleText}>{experience_name}</span>
    </button>
  )
}

BookingItem.propTypes = {
  booking: PropTypes.shape({
    id: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    payment_status: PropTypes.string,
    title: PropTypes.string.isRequired,
    formatted_start_time: PropTypes.string,
    formatted_end_time: PropTypes.string
  }).isRequired,
  conflict: PropTypes.bool,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
  compact: PropTypes.bool,
}

export default memo(BookingItem)
